import styled from "styled-components";

export const Container = styled.div``;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  justify-content: space-between;

  margin-bottom: 30px;

  svg {
    width: 26px;
    height: 26px;
    color: var(--fixit);

    cursor: pointer;
  }

  .title {
    font-size: 20px;
    color: var(--fixit);
    font-weight: 500;
  }
`;

export const InputLine = styled.div`
  margin-top: 16px;
  width: 100%;
`;

export const InputContainer = styled.div`
  flex: 1;
`;

export const Footer = styled.div`
  margin-top: 30px;

  button {
    width: 100%;
  }
`;
